import { GetterTree } from "vuex";
import { CustomFieldsState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<CustomFieldsState, RootState> = {
};
